<form [formGroup]="pairingForm">
  <input type="text" placeholder="level id" formControlName="levelId" />
  <input type="text" placeholder="ladder id" formControlName="ladderId" />
  <button (click)="doitSingles($event)">do it singles</button>
  <button (click)="doitDoubles($event)">do it doubles</button>
</form>

<div *ngIf="results.length > 0" style="margin-top: 20px;">
  <p *ngFor="let r of results">{{r}}</p>
</div>